import React from "react";
import { useNavigate } from "react-router-dom";
import ServicesImage from "../../assets/images/young-doctor-gesturing-thumb.png";
import IconHome from "../../assets/icons/home.svg";
import IconResidential from "../../assets/icons/hart.svg";
import IconSupport from "../../assets/icons/support.svg";
import CustomButton from "../Form/CustomButton";

const services = [
  {
    icon: IconHome,
    title: "Outreach Care",
    description:
      "Sometimes, the best place to heal and feel safe is home. Our support workers visit your loved one where they’re most comfortable, helping with daily routines, meals, medication, or just being there to talk and keep them company.",
  },
  {
    icon: IconResidential,
    title: "Residential Care",
    description:
      "When living at home isn’t the best option, we offer a warm, friendly place where care is always close by. It’s more than just a facility, it’s a real home, with friendly faces, cosy spaces, and round-the-clock support.",
  },
  {
    icon: IconSupport,
    title: "Supported Living",
    description:
      "For those who want to live on their own but still need a hand now and then, we’re here. Whether it’s managing a few tasks or just having someone cheque in, we help people stay confident, safe, and independent.",
  },
];

const ServicesSection = () => {
  const navigate = useNavigate();

  const handleReadMoreClick = () => {
    navigate("/services");
  };

  return (
    <section className="bg-[#EAF6F9] py-10 px-6 lg:px-[60px] xl:px-[100px] mb-[100px]">
      <div className="max-w-screen-xl mx-auto">
        {/* Responsive Container */}
        <div className="flex flex-col lg:flex-row xl:flex-row xl:items-start gap-10 xl:mb-12">
          {/* Left - Text Section */}
          <div className="w-full xl:w-1/2 flex flex-col justify-between h-full font-poppins text-center lg:text-left items-center lg:items-start">
            <div>
              <h4 className="text-[var(--primary-orange-color)] text-[24px] lg:text-[32px] xl:text-[36px] font-semibold mb-2 uppercase">
                Our Services
              </h4>

              <h2 className="text-[14px] lg:text-[22px] xl:text-[25px] font-semibold text-green mb-6">
                Thoughtful Care, Tailored to Every Need
              </h2>

              <p className="text-[var(--light-gray-color)] text-[12px] lg:text-[18px] xl:text-[20px] xl:text-justify font-light mb-4">
                From personal support to skilling up and achieving independence, our team is trained to handle it all, always with a gentle touch and a kind heart.  Whatever your loved one needs, we're here to help them live life comfortably and confidently.
              </p>
            </div>

            {/* Button always at bottom */}
            <div className="mt-6 sm:mt-10">
              <CustomButton
                bgColor="bg-[var(--primary-orange-color)]"
                buttonText="Read More"
                width="w-36"
                textColor="text-white"
                textWeight="font-semibold"
                className={
                  "hover:bg-white hover:border-[var(--primary-orange-color)] hover:text-[var(--primary-orange-color)]"
                }
                onClick={handleReadMoreClick}
              />
            </div>
          </div>

          {/* Right - Image Section */}
          <div className="w-full xl:w-1/2">
            <img
              src={ServicesImage}
              alt="Services"
              className="rounded-xl object-contain w-full h-[350px]"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
            />
          </div>
        </div>
        {/* Service Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 font-poppins">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 shadow-[4px_4px_32px_var(--orange-shadow-color)] hover:shadow-md hover:bg-[#F6867A33] transition"
            >
              <img
                src={service.icon}
                alt={service.title}
                className="w-[30px] h-[30px] lg:w-[40px] lg:h-[40px] xl:w-[60px] xl:h-[60px] mb-4"
                loading="lazy"
                decoding="async"
                fetchpriority="low"
              />
              <h3 className="text-[14px] lg:text-[22px] xl:text-[24px]  font-bold text-green mb-4">
                {service.title}
              </h3>
              <p className="text-[12px] lg:text-[18px] xl:text-[20px] text-justify font-light text-[var(--light-gray-color)]">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
